
import { BrowserRouter } from "react-router-dom";
import { Suspense, useEffect } from "react";
import { AppRoutes } from "@/components/routing/AppRoutes";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as SonnerToaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { useTranslation } from "react-i18next";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import i18n from "@/i18n/i18n";

// Component to handle language initialization
const LanguageInitializer = () => {
  const { i18n } = useTranslation();
  
  useEffect(() => {
    // Set HTML lang attribute to Danish only
    document.documentElement.lang = 'da';
    localStorage.setItem('language', 'da');
    
    // Force Danish language
    i18n.changeLanguage('da');
    
    // Force reload translations to ensure they're applied correctly
    i18n.reloadResources('da');
    
    console.log("Language initialized to Danish");
  }, [i18n]);
  
  return null;
};

function App() {
  useEffect(() => {
    // Set Danish as default language and prevent changes
    i18n.changeLanguage('da');
    document.documentElement.lang = 'da';
    localStorage.setItem('language', 'da');
    
    // Force reload translations to ensure they're applied correctly
    i18n.reloadResources('da');
    
    console.log("App initialized with Danish language");
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <Suspense fallback={<div>Indlæser...</div>}>
          <LanguageInitializer />
          <AppRoutes />
          <Toaster />
          <SonnerToaster position="top-right" closeButton />
          {process.env.NODE_ENV !== "production" && <ReactQueryDevtools />}
        </Suspense>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
